import { Component, Input } from '@angular/core';
import { Heimtier } from '../../kalender/heimtier-kalender-eintrag';

@Component({
    selector: 'kiene-heimtier-info',
    templateUrl: './heimtier-info.component.html',
    styleUrls: ['./heimtier-info.component.scss'],
})
export class HeimtierInfoComponent {
    @Input() heimtier: Heimtier;
}
